<template>
  <div class="watchlist">
    <ith-top-bar />
    <ith-banner :item="banner" />
    <ith-sad-top />

    <ith-watchlist-grid />
    <ith-sad-bottom />

    <ith-footer />
  </div>
</template>

<script>
export default {
  name: "Watchlist",
  metaInfo: {
    title: "OTT Watchlist - Track Movies Watched and TV Shows Online",
    meta: [
      {
        name: "description",
        content:
          "Track movies watched and TV Shows with OTT Watchlist. Get free access to the top movies and organize your watchlist with the best popular TV shows.",
      },
      {
        name: "keywords",
        content:
          "OTT Watchlist, Track movies watched, TV Shows, top movies, best popular TV shows.",
      },
    ],
  },

  data: () => ({
    banner: {
      image: "./img/banners/RECOMMENDED.png",
    },
  }),
  created() {
    this.$store.commit("DISABLED_MENU");
    this.$store.commit("EDIT_CRITERIA", "");
  },

  methods: {},
};
</script>

<style scoped>
.watchlist {
  background-color: #2c3848;
}
.separate {
  height: 100px;
}
</style>
